import { styled } from '@mui/material/styles';

const StyledChartWrapper = styled('div')(({ theme, sx }) => ({
    // '& .apexcharts-canvas svg':
    // '& .apexcharts-canvas svg,.apexcharts-canvas foreignObject': {
    //
    // },
    // '& .apexcharts-legend': {
    //
    // }
    // legend to right
    ...sx,
    '& .apexcharts-canvas .apexcharts-legend-series': {
        borderRadius: '20px',
        borderColor: theme.palette.divider,
        borderStyle: 'solid',
        borderWidth: 1,
        padding: '4px 10px',
        backgroundColor: theme.palette.background.neutral
    }
}));

export default StyledChartWrapper;
